import api from '@/apis/BaseApi';
import { ManagerEntryInfoModel } from '@/apis/models/ManagerModel';

export default class ManagerApi {
  static async getManagerEntryInfo(): Promise<ManagerEntryInfoModel> {
    const result = await api.get('account/manager/entry');
    return result.data;
  }
}
